import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@atlant/ui"

import type { FleetScope } from "./fleet-filter-store.ts"

const options: { value: FleetScope; label: string }[] = [
  { value: "all", label: "All fleet" },
  { value: "my", label: "My fleet" },
]

interface FleetScopeSelectProps {
  value: FleetScope
  onChange: (value: FleetScope) => void
}

export const FleetScopeSelect = ({ value, onChange }: FleetScopeSelectProps) => {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as FleetScope)}>
      <SelectTrigger className="gap-1.5 border-none text-sm font-medium shadow-none">
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
